import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { payoutColors, type PayoutStatus } from '@/lib/payouts';

export function PayoutBadge({ status }: { status?: PayoutStatus | string | null }) {
  const { t } = useTranslation();
  if (!status) return null;
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap', payoutColors[status as PayoutStatus] ?? 'bg-muted text-muted-foreground')}>
      {t(`mur_payout.status.${status}`, { defaultValue: status })}
    </span>
  );
}

/** T232: the customer signed the contract, but the merchant → Hisob invoice was rejected or failed — a signal only. */
export function InvoiceProblemBadge({ show }: { show?: boolean | null }) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <span className="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap bg-destructive/15 text-destructive" title={t('mur_payout.invoice_problem_hint')}>
      {t('mur_payout.invoice_problem')}
    </span>
  );
}
